import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { placement: String }

  connect () {
    this.element.addEventListener('click', this._handleClick.bind(this), false)
  }

  // -----------------------------------------------------------------------------------------------

  // Якщо publisher.js не завантажився (адблок, збій CDN), клік не перехоплюємо:
  // посилання веде на сторінку налаштування джерел — фолбек із документації Google.
  _handleClick (event) {
    if (!window.preferredSourceReady) { return }

    event.preventDefault()
    this._track()
    window.preferredSourceReady.then(preferredSource => preferredSource.addPreferredSource())
  }

  _track () {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'preferred_source_click', placement: this.placementValue })
  }
}
